import React from 'react';
import { Link } from '@scentregroup/shared/link';
import { BasicPageContext } from '../../../context';
import style from './index.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const StoreLink = props => {
  const store = props.store;
  const centreSlug = props.centreSlug;
  const url = "/".concat(centreSlug, "/store/").concat(store.sys.id, "/").concat(store.slug);
  return /*#__PURE__*/_jsx(BasicPageContext.Consumer, {
    children: isBasicPage => {
      if (isBasicPage) {
        return store.title;
      }
      return /*#__PURE__*/_jsx(Link, {
        to: url,
        className: style.nearestStore,
        "data-id": "parking-zone_store-link_StoreLink_Link",
        children: store.title
      }, store.sys.id);
    }
  });
};
export default StoreLink;